// SignInScreen.js - ফিক্সড ভার্সন
import React, {useState, createRef, useEffect, useRef} from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  TextInput,
  KeyboardAvoidingView,
  Platform,
  Dimensions,
  Image,
  Keyboard,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import {useNavigation} from '@react-navigation/native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import Loader from '../components/Loader';

const {width, height} = Dimensions.get('window');

const LoginScreen = () => {
  const [Username, setUsername] = useState('');
  const [UserPassword, setUserPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errortext, setErrortext] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [secureEntry, setSecureEntry] = useState(true);
  const navigation = useNavigation();
  const passwordInputRef = createRef();

  const handleSubmitPress = () => {
    setErrortext('');
    if (!Username) {
      alert('Please fill Username');
      return;
    }
    if (!UserPassword) {
      alert('Please fill Password');
      return;
    }
    setLoading(true);

    let dataToSend = {
      apps_user_type: 2,
      username: Username,
      password: UserPassword,
    };
    let formBody = [];
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');

    try {
      let url =
        'https://reactnative.bdlawservice.com/public/api/appsAndWebLogin';

      axios
        .post(url, formBody)
        .then(response => {
          setLoading(false);
          if (response.data.code === 200 || response.data.code === 504) {
            AsyncStorage.clear();
            AsyncStorage.setItem('user_name', Username);
            AsyncStorage.setItem('user_id', Username);
            AsyncStorage.setItem('user_password', JSON.stringify(UserPassword));
            if (response.data.user_info) {
              AsyncStorage.setItem(
                'name',
                JSON.stringify(response.data.user_info.name),
              );
              AsyncStorage.setItem(
                'mobile_no',
                JSON.stringify(response.data.user_info.mobile_no),
              );
            }
            navigation.replace('Root');
          } else {
            setErrortext(response.data.msg);
          }
        })
        .catch(error => {
          setLoading(false);
          console.error(error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <View style={styles.mainBody}>
      <Loader loading={loading} />
      <KeyboardAvoidingView
        style={styles.keyboardView}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      >
        <ScrollView
          contentContainerStyle={styles.scrollContainer}
          keyboardShouldPersistTaps="handled"
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.container}>
            {/* Header */}
            <View style={styles.headerContainer}>
              <Text style={styles.headerTitle}>Search List User Login</Text>
              <View style={styles.headerLine} />
            </View>

            {/* Login Form */}
            <View style={styles.cardContainer}>
              <Text style={styles.labelText}>User Code No :</Text>
              <View style={styles.inputWrapper}>
                <TextInput
                  value={Username}
                  style={styles.inputStyle}
                  onChangeText={setUsername}
                  placeholder="Enter Your Username"
                  placeholderTextColor="#999"
                  autoCapitalize="none"
                  returnKeyType="next"
                  onSubmitEditing={() => passwordInputRef.current?.focus()}
                  underlineColorAndroid="transparent"
                  blurOnSubmit={false}
                />
              </View>

              <Text style={styles.labelText}>Password</Text>
              <View style={styles.inputWrapper}>
                <TextInput
                  value={UserPassword}
                  style={styles.inputStyle}
                  onChangeText={setUserPassword}
                  placeholder="Enter Your Password"
                  placeholderTextColor="#999"
                  ref={passwordInputRef}
                  onSubmitEditing={Keyboard.dismiss}
                  blurOnSubmit={false}
                  secureTextEntry={secureEntry}
                  underlineColorAndroid="transparent"
                  returnKeyType="done"
                />
                <TouchableOpacity
                  style={styles.eyeButton}
                  onPress={() => setSecureEntry(!secureEntry)}
                >
                  <Icon
                    name={secureEntry ? 'visibility-off' : 'visibility'}
                    size={22}
                    color="#666"
                  />
                </TouchableOpacity>
              </View>

              {errortext !== '' && (
                <Text style={styles.errorTextStyle}>{errortext}</Text>
              )}

              <View style={styles.rememberRow}>
                <TouchableOpacity
                  style={styles.rememberContainer}
                  onPress={() => setRememberMe(!rememberMe)}
                  activeOpacity={0.7}
                >
                  <View
                    style={[
                      styles.checkbox,
                      rememberMe && styles.checkboxChecked,
                    ]}
                  >
                    {rememberMe && <Text style={styles.checkmark}>✓</Text>}
                  </View>
                  <Text style={styles.rememberText}>Remember me</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.loginButton}
                  activeOpacity={0.8}
                  onPress={handleSubmitPress}
                >
                  <Text style={styles.buttonTextStyle}>Login</Text>
                </TouchableOpacity>
              </View>
            </View>

            {/* Logo */}
            <Image
              source={require('../../assets/icon.png')}
              resizeMode="contain"
              style={styles.image}
            />
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </View>
  );
};

const styles = StyleSheet.create({
  mainBody: {
    flex: 1,
    backgroundColor: '#307ecc',
  },
  keyboardView: {
    flex: 1,
  },
  scrollContainer: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
    paddingVertical: 30,
  },
  container: {
    width: '100%',
    alignItems: 'center',
  },
  headerContainer: {
    alignItems: 'center',
    marginBottom: 20,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#fff',
    letterSpacing: 1,
    textAlign: 'center',
  },
  headerLine: {
    width: 60,
    height: 3,
    backgroundColor: '#fff',
    marginTop: 5,
    borderRadius: 2,
  },
  cardContainer: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 24,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 10,
  },
  labelText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
    marginBottom: 4,
    marginTop: 8,
  },
  inputWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    backgroundColor: '#fff',
    height: 46,
    marginBottom: 4,
  },
  inputStyle: {
    flex: 1,
    height: 46,
    paddingHorizontal: 13,
    fontSize: 15,
    color: '#333',
  },
  eyeButton: {
    paddingHorizontal: 12,
    height: 46,
    justifyContent: 'center',
    alignItems: 'center',
  },
  errorTextStyle: {
    color: 'red',
    textAlign: 'center',
    fontSize: 14,
    marginTop: 8,
    marginBottom: 4,
  },
  rememberRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 12,
    flexWrap: 'wrap',
  },
  rememberContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
  },
  checkbox: {
    width: 22,
    height: 22,
    borderWidth: 2,
    borderColor: '#307ecc',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  checkboxChecked: {
    backgroundColor: '#307ecc',
  },
  checkmark: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
  },
  rememberText: {
    fontSize: 14,
    color: '#333',
  },
  loginButton: {
    backgroundColor: '#307ecc',
    paddingHorizontal: 30,
    paddingVertical: 10,
    borderRadius: 6,
    minWidth: 90,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 40,
  },
  buttonTextStyle: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
  },
  image: {
    marginTop: 30,
    width: 80,
    height: 80,
    borderRadius: 40,
    alignSelf: 'center',
  },
});

export default LoginScreen;
